import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { listGame, resetListGame } from '../../redux/slices/GameSlice';
import { FormattedMessage } from "react-intl";
import GeneralService from '../../apis/GeneralService';
import ApiURL from '../../apis/ApiURL';
import Constants from '../../utility/Constants';
import { useLocation, useNavigate } from 'react-router-dom';
import gameLunchHandler from '../../utility/Helpers';

const Games = ({ category_id, game_name, provider_id, provider_name, useCommonCallback, refreshTrigger }) => {
  const navigte = useNavigate();
  const dispatch = useDispatch();
  let gameState = useSelector((state) => state.gameState);
  
  const userDetailState = useSelector((state) => state.userDetailState);
  const languageState = useSelector((state) => state.languageState);
  let languageCode = languageState.active_language.language_code;
  let token = userDetailState?.user_details?.token ? userDetailState?.user_details?.token : ""

  let [loading, setLoading] = useState(true);
  let [limit, setLimit] = useState(24);

  let newPage = 1;
  let [page, setPage] = useState(1);
  let [totalPage, setTotalPage] = useState(1);


  async function loadGameList() {
    let params;
    if(provider_id){
      params = JSON.stringify({
        "category_id": category_id ? category_id.toString() : "",
        "game_name": game_name ? game_name : "",
        "provider_id": provider_id
      })
    } else {
    params = JSON.stringify({
      "category_id": category_id ? category_id.toString() : "",
      "game_name": game_name ? game_name : "",
    })
  }

    GeneralService.apiPostCallRequest(`${ApiURL.getGameList}?page=${newPage}&limit=${limit}`, params, userDetailState.user_details.token).then(res => {

      if (res.error == Constants.API_RESPONSE_ERROR_FALSE) {
        setLoading(false)

        setTotalPage(res.data.pages);

        dispatch(listGame(res.data.games))

      }

    }).catch(error => {
      setLoading(false)
    })

  }

  useEffect(() => {
    window.scrollTo(0, 0)
    setPage(1)
    dispatch(resetListGame())
    loadGameList();

  }, [category_id, game_name, refreshTrigger])

  const loadMoreClick = () => {
    newPage = page + 1;
    setPage(newPage);
    loadGameList();
  }
// for game launch loader
  const [launching, setLaunching] = useState(false);
  const handleClick = (gameData, languageCode, token, game_mode) => {
    console.log('launching==>', launching);
    setLaunching(true);
    gameLunchHandler(gameData, languageCode, token, game_mode, useCommonCallback, provider_name).finally(() => {
      console.log('launching==>', launching);
      setLaunching(false);
    });
    
  };
  const demoPlayProviders = ["Boongo", "Pragmatic Play", "NetEnt", "Big Time Gaming", "Red Tiger", "Nolimit City - 94", "Nolimit City - 96", "Tap-A-Roo", "Jili", "Betsoft", "Qora", "Evoplay", "Slotopia", "Novomatic", "Penguin King", "Play N Go", "Triple Profits Games", "JDB", "Allbet", "BGaming", "Dragoon Soft", "Expanse", "Skywind", "1X2 Gaming", "Dream Gaming", "GamePlay Interactive", "Microgaming Live", "AvatarUX", "Blueprint Gaming", "Relax Gaming", "Hacksaw Gaming", "Slotmill", "Yggdrasil", "Fantasma", "Habanero", "WorldMatch", "Sigma", "Kalamba", "Mobilots", "OneTouch", "Revolver Gaming", "Realtime Gaming", "PLAYSTAR" ,"Simpleplay", "Nolimit City - 92", "WonWon", "QoraGenesis", "Qora", "Iron Dog Studio", "Kiron", "WM Casino", "Quickspin", "Thunderkick", "CosmoPlay", "EEAI"];

  return (
    <>
      <div className='container'>
        <div className='povider-game-list-section' id="style-2">
          
            {loading ?
            <div className='row w-100 d-flex align-items-center justify-content-center'>
              <div className="spinner-border text-primary" role="status" style={{ marginTop: "20px" }}>
                <span className="visually-hidden"></span>
              </div>
            </div> : ""
            }
          
          {gameState.game_list?.length > 0 ? gameState.game_list.map((gameData, gameIndex) => (
            // <div className='col-2' onClick={() => handleClick(gameData.game_code, languageCode, token)}>
            //   <div className='each-game-card' key={gameIndex}>
            //     <img className='each-game-card-img w-100' src={gameData.image_file_name} alt='game_card_img' />
            //     <div className='game-detail-section'>

            //       <span className='game-detail-playing'>{gameData?.game_name[languageCode]}</span>
            //       <span className='game-provider-name'>{gameData?.provider_name[languageCode]}</span>
            //     </div>
            //   </div>
            // </div>


            <div className='each-game-card'>
                                  {/* Image */}
                                  <img className='each-game-card-img w-100'
                                    src={Constants.PROVIDERS_WITH_RESIZED_IMAGES.includes(gameData.provider_name) ? gameData.image_file_name.replace('/game/', '/250x250/') : gameData.image_file_name}
                                    alt='game_img'
                                  />
                                  {/* Hover buttons */}
                                  <div className="game-hover-actions">

                                    {/* Real Play always visible */}
                                    <button
                                      className="play-btn real-play"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleClick(gameData, languageCode, token, 'real');
                                      }}
                                    >
                                      <i className="fa-solid fa-play"></i>
                                      Play
                                    </button>

                                    {/* Dummy Play - show only if provider is in allowed list */}
                                    {demoPlayProviders.includes(gameData.provider_name) && (
                                      <button
                                        className="play-btn dummy-play"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleClick(gameData, languageCode, token, 'fun');
                                        }}
                                      >
                                        <i className="fa-solid fa-gamepad"></i>
                                        Demo Play
                                      </button>
                                    )}

                                  </div>

                                  {/* Details */}
                                  <div className='game-detail-section'>
                                    <span className='game-detail-playing'>{gameData.game_name[languageCode]}</span>
                                    <span className='game-provider-name'>{gameData.provider_name[languageCode]}</span>
                                  </div>
                                </div>
          )) :
            ""
          }

          {
            (loading == false && gameState.game_list.length == 0) ?
              <div className="alert alert-primary no_game_found" role="alert">
                <FormattedMessage id='NOGAMEFOUND' />
              </div> : ""
          }


          {(totalPage == page) ? "" :
            <div className='load_more_button_div'>
              <button className='load_more_button' onClick={loadMoreClick}
                hidden={totalPage == 0 ? true : false}>
                <FormattedMessage id='LOADMORE' />
              </button>
            </div>}
        </div>
      </div>
      {launching && (
        <div className="launch-overlay">
          <div className="launch-spinner"></div>
          <span className="launch-text">Launching your game...</span>
        </div>
      )}

      <style>{`
        .launch-btn {
          padding: 10px 16px;
          background: #28a745;
          border: none;
          color: #fff;
          border-radius: 8px;
          cursor: pointer;
          font-weight: bold;
        }

        .launch-overlay {
          position: fixed;
          top: 0; left: 0;
          width: 100vw; height: 100vh;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .launch-spinner {
          width: 60px;
          height: 60px;
          border: 8px solid #eee;
          border-top: 8px solid #28a745;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .launch-text {
          margin-top: 16px;
          color: white;
          font-size: 1.2rem;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .each-game-card {
                    position: relative;
                    overflow: hidden;
                    cursor: pointer;
                }

                .game-hover-actions {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 86%;
                    background: rgba(0,0,0,0.65);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    opacity: 0;
                    transition: opacity .3s ease;
                    gap: 10px;
                }

                .each-game-card:hover .game-hover-actions {
                    opacity: 1;
                }

                .play-btn {
                    background: #ffffff;
                    color: #000;
                    padding: 8px 14px;
                    border-radius: 8px;
                    border: none;
                    font-size: 14px;
                    display: flex;
                    gap: 6px;
                    align-items: center;
                    cursor: pointer;
                    font-weight: 600;
                }

                .play-btn:hover {
                    background: #e6e6e6;
                }

                .real-play {
                    border-left: 4px solid #28a745;
                }

                .dummy-play {
                    border-left: 4px solid #ff9800;
                }
      `}</style>
    </>
  )
}

export default Games
